<template>
  <div class="express">
    <div
      v-if="list.length > 1"
      class="font-size-12 express-choose"
      @click="show = true"
    >
      {{ $t('checkout.change') }}
    </div>
    <q-dialog v-model="show" position="bottom" @show="temp = shipping.cur">
      <q-card class="express-card">
        <div class="express-head">
          <span class="font-size-14 express-title">{{
            $t('checkout.changeDeliveryTitle')
          }}</span>
          <q-icon v-close-popup name="svg:oclose" class="type-close" />
        </div>
        <div
          v-for="(item, index) in shipping.list"
          :key="index"
          class="express-body"
          @click="temp = item"
        >
          <div class="express-body-lf">
            <span
              :class="['express-body-icon', { active: temp.id === item.id }]"
            />
            <img
              :src="`https://static.bakmigm.co.id/menu/${item.name}.png`"
              class="delivery-gosend-icon"
            />
          </div>
          <span class="express-body-rg">
            {{ $n(item.cost, 'currency', 'id-ID') }}
          </span>
        </div>

        <div class="express-footer">
          <button @click="onApply">{{ $t('checkout.apply') }}</button>
        </div>
      </q-card>
    </q-dialog>
  </div>
</template>
<script>
export default {
  // eslint-disable-next-line vue/require-prop-types
  props: ['shipping'],
  data() {
    return {
      show: false,
      temp: {},
    };
  },
  computed: {
    cur() {
      return this.shipping.cur || {};
    },
    list() {
      return this.shipping.list || [];
    },
  },
  methods: {
    onApply() {
      this.show = false;
      if (this.cur.id === this.temp.id) return;
      this.$emit('use', this.temp.id);
    },
  },
};
</script>
<style lang="scss" scoped>
.express {
  &-choose {
    color: $primary;
  }
  &-head {
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
  }
  &-card {
    padding: 16px 16px 0;
    .delivery-gosend-icon {
      width: 90px !important;
      height: 24px !important;
    }
  }
  &-title {
    font-weight: 800;
    line-height: 18px;
  }
  &-body {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 0;
    &-icon {
      display: inline-block;
      width: 20px;
      height: 20px;
      border: 2px solid #d1d5db;
      border-radius: 50%;
      margin-right: 10px;
      &.active {
        background: url(../../../assets/icons/png/checked.png) center center
          no-repeat;
        border: none;
      }
    }
    &-lf {
      display: flex;
    }
    &-rg {
      font-weight: 800;
    }
  }
  &-footer {
    margin: 12px auto;
    button {
      width: 100%;
      height: 40px;
      line-height: 40px;
      border: none;
      background: $primary;
      outline: none;
      box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
      border-radius: 8px;
      color: #fff;
      font-weight: bold;
    }
  }
}
</style>
